/* External Imports */
import { Box, Text } from '@chakra-ui/react';
/* Internal Imports */
/* Components */
import config from '@config';
import LazyLoadImageComponent from '@components/UI/LazyLoadImageComponent';
/* Styles */
import styles from "@lb/Sections/aboutDevi/styles.module.css"


const AboutDeviSlide9 = ({ section }) => {
  return (
    <Box bgColor="#000" className={styles.section9Bg}>
      <Box
        maxW="1200px"
        mx="auto"
        minH="100vh"
        display="flex"
        position="relative"
        alignItems="center"
        justifyContent="space-between"
        flexDir={{ base: 'column', lg: 'row' }}
      >
        <Box
          maxW="366px"
          w={{ base: '90%', md: '100%' }}
          textAlign="center"
          mr={{ base: '0px', md: '34px' }}
          p="2rem"
        >
          <Text color="#D09700" fontSize={{ base: '20px', lg: '30px' }}>
            <span style={{ color: '#fff' }}>
              {section?.sectionContent?.[0]?.text?.slice(0, 18)}
            </span>
            {section?.sectionContent?.[0]?.text?.slice(18, -1)}
          </Text>
        </Box>
        <Box maxW="800px" w="100%" textAlign="center">
          <LazyLoadImageComponent
            src={`${config.imgPath}/d/46272/1684474074-sciencecreatinggoddessesslide.jpg`}
            alt="ScienceCreatingGoddessesSlide"
            width="100%"
            height="auto"
            maxW="515px"
          />
        </Box>
      </Box>
    </Box>
  );
};
export default AboutDeviSlide9;
